import { Alert, Snackbar } from "@mui/material";
import { useFeedback } from "../../features/admin/hooks/FeedbackContext";

export default function GlobalSnackbar() {
  const { feedback, hideFeedback } = useFeedback();

  return (
    <Snackbar
      open={feedback.open}
      autoHideDuration={4000}
      onClose={hideFeedback}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        severity={feedback.severity}
        onClose={hideFeedback}
        variant="filled"
      >
        {feedback.message}
      </Alert>
    </Snackbar>
  );
}